import { connect } from 'react-redux'
import ChangePasswordDialog from './ChangePasswordDialog'
import * as actions from '../../redux/authentication'
export default connect(null, actions)(ChangePasswordDialog)
